import React, { useEffect } from 'react';

import AerospaceInsightsCards from './AerospaceInsightsCards';

import EnergyPagedataBanner from './EnergyPagedataBanner';
import EnergyPageSecondverticalTabs from './EnergyPageSecondverticalTabs';
import Itrequestform from './Itrequestform';
import Footer from './Footer';
import EnergypageCargot from './EnergypageCargot';
import EnergyCrigotmobile from './EnergyCrigotmobile';
import EnergyPageButtons from './EnergyPageButtons';
import EnergyPageDatas from './EnergyPageDatas';
import EnergyPageVerticalTabs from './EnergyPageVerticalTabs';
import Energypagethirdtab from './Energypagethirdtab';
const EnergyPagedata = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures it only runs once when the component mounts
  // Scroll to the top of the page when the component mounts

  return (
    <div style={{ background: '#fff' }}>



      <EnergyPagedataBanner />
      <EnergyPageButtons />
      <EnergyPageDatas />
      <EnergyPageVerticalTabs />

      <EnergyPageSecondverticalTabs />
      <Energypagethirdtab />
      {/* <Crigotpage /> */}
      <EnergypageCargot />
      <div className='mobile-crigot'>
      <EnergyCrigotmobile />
      </div>


      {/* <AerospaceInsightsCards /> */}
      <br></br>
      <Itrequestform />
      <div style={{ marginTop: "-60px" }}>
        <Footer />
      </div>

      {/* <style>
        {`
           h1,h2,h3,h4,h5,h6,p{
          font-family: urbanist , sarif;
          }
          `}
      </style> */}
      <style>
        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
      </style>
    </div>
  )
}

export default EnergyPagedata;